export const blockIconsUiactionsDoneNew = (
	<span className='material-symbols-outlined'>done</span>
);
